(function () {
  function openModal(modal) {
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-works-with-trigger]');
    if (trigger) {
      var modal = document.getElementById(trigger.getAttribute('data-modal-id'));
      if (modal) {
        event.preventDefault();
        openModal(modal);
      }
      return;
    }

    var closeBtn = event.target.closest('[data-modal-close]');
    if (closeBtn) {
      var panel = closeBtn.closest('.app-download-hub__modal');
      if (panel) closeModal(panel);
      return;
    }

    var backdrop = event.target.closest('.app-download-hub__modal.is-open');
    if (backdrop && event.target === backdrop) {
      closeModal(backdrop);
    }

    var klaviyoLink = event.target.closest('[data-klaviyo-form]');
    if (klaviyoLink) {
      var formId = klaviyoLink.getAttribute('data-klaviyo-form');
      if (formId && window._klOnsite) {
        event.preventDefault();
        window._klOnsite.push(['openForm', formId]);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.app-download-hub__modal.is-open').forEach(closeModal);
  });
})();
